import tw from "tailwind-styled-components"

export const Theme = tw.div `
    
bg-gray-100 
dark:bg-gray-800
 dark:text-white
 text-gray-700
`

export const CardTheme = tw.div `

 
    
 dark:text-white
 rounded-2xl
 text-gray-700
    
`